import { render, staticRenderFns } from "./modalQuestionP2h.vue?vue&type=template&id=71bef6d9&scoped=true"
import script from "./modalQuestionP2h.vue?vue&type=script&lang=js"
export * from "./modalQuestionP2h.vue?vue&type=script&lang=js"
import style0 from "./modalQuestionP2h.vue?vue&type=style&index=0&id=71bef6d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bef6d9",
  null
  
)

export default component.exports